import { createApi } from "@reduxjs/toolkit/query/react";
import { Endpoints } from "services/urls";
import { baseQuery } from "../utils/baseQuery";
import { apiHelper } from "utils/apiHelper";
import { INoitifications, INotificationsQuery } from "types/notification.types";

const NotificationsApi = createApi({
  reducerPath: "notifications-api",
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    getNotificationsList: builder.query<INoitifications, INotificationsQuery>({
      query: (body) => apiHelper(Endpoints.notifications.list, body),
    }),
    pushNotification: builder.mutation({
      query: (body) => ({
        url: Endpoints.notifications.pushNotification,
        body,
        method: "POST",
      }),
    }),
  }),
});

export const { useGetNotificationsListQuery, usePushNotificationMutation } = NotificationsApi;
export { NotificationsApi };
